import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

export const getNotifications = createAsyncThunk(
  "not/getNotifications",
  async (data = {}, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      action_type = "",
      type = "",
      is_read = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      action_type,
      type,
      is_read,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/notifications?${queryString}`, //endpoint
      });
      console.log(response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// link fcm token with user after logging in
export const linkFCMToken = createAsyncThunk(
  "not/linkFCMToken",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/user-fcm-token", // endpoint for family members
        data: data,
      });
      console.log(response, "link fcm token response");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// mark notification read
export const markNotificationsRead = createAsyncThunk(
  "not/markRead",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: "/read-notifications", // endpoint for family members
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
